import { GET_BENEFIT_DOMAINS, GET_BENEFIT_DOMAINS_SUCCESS, GET_BENEFIT_DOMAINS_ERROR, GET_BENEFIT_DOMAINS_EMPTY } from './../../actionType';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetBenefitDomains = (state = initialState, action) => {
  switch (action.type) {
    case GET_BENEFIT_DOMAINS:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_BENEFIT_DOMAINS_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };

      break;

    case GET_BENEFIT_DOMAINS_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_BENEFIT_DOMAINS_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetBenefitDomains;
